import React from "react";
import styles from "./Toggle.module.scss";

export class Toggle extends React.Component {
  render() {
    const {
      handleChange,
      checked = false,
      disabled = false,
      name
    } = this.props;

    return (
      <div className={styles["main-input-toggle"]}>
        <label className={styles["switch"]}>
          <input
            disabled={disabled}
            type="checkbox"
            data-automation-id="toggle"
            onChange={handleChange}
            checked={checked}
            name={name}
          />
          <span className={styles["slider"] + " " + styles["round"]}></span>
        </label>
      </div>
    );
  }
}

export default Toggle;
